import server from "src/api/server";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import Seo from "src/components/shared/Seo";
const ContactUsPage = dynamic(() =>
  import("src/modules/ContactUsPage/ContactUsPage")
);

export default function ContactUs({
  data,
  appSetting = {},
  metaData = [],
  footerData,
  footerSettings,
}) {
  const router = useRouter();
  const { locale } = router;

  const footer = footerData || footerSettings;

  const customMeta = [
    { name: "title", content: metaData?.[0]?.name?.[locale] },
    {
      name: "description",
      content: metaData?.[0]?.content?.[locale],
    },
  ];

  return (
    <div>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footer,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />

      <ContactUsPage data={data} footerData={footer} />
    </div>
  );
}

export async function getStaticProps() {
  try {
    const [footerRes, metaRes, indexRes, questionsRes] = await Promise.all([
      server.get("/api/footer"),
      server.get("/api/metadataTags?type=contact"),
      server.get("/api/index"),
      server.get("/api/posts/questions_contact/all"),
    ]);

    const appSetting = indexRes?.data?.data?.AppSetting;

    return {
      props: {
        data: {
          questions: questionsRes?.data?.data || null,
        },
        metaData: metaRes?.data?.data?.metadata_tags || [],
        appSetting: appSetting || null,
        footerData: footerRes?.data?.data || null,
        footerSettings: footerRes?.data?.data || null,
      },
      revalidate: 60,
    };
  } catch (error) {
    return {
      props: {
        data: { questions: null },
        metaData: [],
        appSetting: null,
        footerData: null,
        footerSettings: null,
      },
      revalidate: 60,
    };
  }
}
